import http from "@/request"


/**
 * 获取单据类别数据
 * @param {*} param 
 * @returns 
 */
export function findInvoiceTypes() {
    return http({
      url: "/dict/invoiceTypes",
      method: "get"
    });
}

/**
 * 获取标签
 * @returns 
 */
export function findTags() {
    return http({
      url: "/dict/tags",
      method: "get"
    });
}

/**
 * 正常的标签
 * @returns 
 */
export function findNormalTags() {
  return http({
    url: "/dict/normalTags",
    method: "get"
  });
}

/**
 * 保存标签
 * @param {*} data 
 * @returns 
 */
export function saveTag(data) {
  return http({
    url: "/dict/saveTag",
    method: "post",
    data: data
  });
}

/**
 * 删除标签
 * @param {*} data 
 * @returns 
 */
 export function deleteTag(data) {
  return http({
    url: "/dict/deleteTag",
    method: "post",
    data: data
  });
}


// WEBPACK FOOTER //
// ./src/api/dict.js